import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { cache, createQuery, localStorageCache } from '@farfetched/core';
import { signout } from '@features/common';
import { getResidentObjectList } from './api';
import type {
  GetResidentObjectListPayload,
  GetResidentObjectListResponse,
  ResidentObjectListData,
} from './types';

export const ResidentObjectListControlGate = createGate<ResidentObjectListData>();

const fxGetResidentObjectList = createEffect<
  GetResidentObjectListPayload,
  GetResidentObjectListResponse,
  Error
>().use(getResidentObjectList);

export const residentObjectListQuery = createQuery({
  effect: fxGetResidentObjectList,
  mapData: ({ result }) =>
    Array.isArray(result?.object_list)
      ? result.object_list.map((item) => ({
          id: item?.area_guid,
          label: item?.area_title ?? '',
          ownershipRelationId: item?.ownership_relation?.id,
        }))
      : [],
});

cache(residentObjectListQuery, {
  adapter: localStorageCache({ maxAge: '5m' }),
  purge: signout,
});

/** Запрос данных */
sample({
  clock: ResidentObjectListControlGate.state,
  source: ResidentObjectListControlGate.status,
  filter: (status, { residentGuid }) => Boolean(status && residentGuid),
  fn: (_, { residentGuid }) => ({
    resident_guid: residentGuid as string,
  }),
  target: residentObjectListQuery.start,
});

sample({
  clock: ResidentObjectListControlGate.close,
  target: residentObjectListQuery.reset,
});

sample({
  clock: residentObjectListQuery.finished.success,
  source: ResidentObjectListControlGate.status,
  filter: (isOpened) => !isOpened,
  target: residentObjectListQuery.reset,
});
